<div class="flex flex-col gap-4">
    <span class="text-base font-semibold text-shui-text-strong">{{
        'request.requestDetail.submission-details' | translate
    }}</span>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[900px]">
        <sh-input-text
            [label]="'request.overview.subject-label' | translate"
            [value]="subject() ?? ''"
            disabled
        ></sh-input-text>
        <sh-input-text
            [label]="'request.overview.shipment-required-by-date' | translate"
            [value]="shipmentDateDisplay()"
            disabled
        ></sh-input-text>
        <sh-input-text
            [label]="'request.overview.comments-label' | translate"
            [value]="reason() ?? ''"
            class="col-span-2"
            textarea
            disabled
        ></sh-input-text>
    </div>
</div>
